import RestClient from './RestClient';
import Config from '../../config/Config';
import { Post } from '../../models';
import _ from 'lodash';

class Posts extends RestClient {
    constructor() {
        super({
            "model": Post,
            "entryPoint": "posts",
            "resource": "post",
            "resources": "posts",
            "sortBy": "date",
        });

        this.baseUrl = Config.wp_end_point;
    }

    list(params) {
        // remove empty filter values
        params = _.pickBy(params, _.identity);

        return this.GET(`/${this.entryPoint}`, params)
            .then(response => response.json())
            .then(json => {
                if (Array.isArray(json)) {
                    json = { posts: json.map(post => new Post(post)) };

                    if (this.sortBy)
                        json.posts = _.sortBy(json.posts, -1 * this.sortBy);

                    return json;
                }
                throw new Error('Could not fetch posts');
            });
    }

    get(id) {
        throw new Error('Posts::get is not implemented');
    }

    create(payload) {
        throw new Error('Posts::create is not implemented');
    }

    update(payload) {
        throw new Error('Posts::update is not implemented');
    }

    duplicate(payload) {
        throw new Error('Posts::duplicate is not implemented');
    }

    delete(id) {
        throw new Error('Posts::delete is not implemented');
    }
}

const PostsApi = new Posts();

export default PostsApi;
